import EmployeesPageView from "./EmployeesPageView";

function EmployeesPage() {
  return <EmployeesPageView />;
}

export default EmployeesPage;
